




































import {
  defineComponent, PropType, toRef,
} from '@nuxtjs/composition-api';
import type { ConfigurableProductOptions } from '~/modules/GraphQL/types';
import { Product } from '~/modules/catalog/product/types';
import productGetters from '~/modules/catalog/product/getters/productGetters';
import type { Price } from '~/modules/catalog/types';

export interface VariantPrices {
  omnibusPrice: number | string | null;
  price: Price
}

export default defineComponent({
  name: 'ProductVariants',
  props: {
    options: {
      type: Array as PropType<ConfigurableProductOptions[]>,
      required: true,
    },
    getIsVariantActive: {
      type: Function as PropType<(optionId: string, attributeId: string) => boolean>,
      required: true,
    },
    onChooseVariant: {
      type: Function as PropType<(optionId: string, attributeId: string) => void>,
      required: true,
    },
    product: {
      type: [Object, null] as PropType<Product>,
      default: null,
    },
    optionRenderValidator: {
      type: Function,
      default: () => true,
    },
  },
});
